<template>
  <div v-bind:class="divModalOpenClass">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="container">
      <article>
        <section class="section white-panel mb2p pt24">
          <h2 class="fs16">精算金額</h2>
          <div class="flex mb16">
            <p class="flex1 fs40 line-height1 font-weight-bold mb0">{{ $filters.addComma(inspectionSettlement.Amount) }}<span class="ml4 fs20 va-middle">円</span></p>
            <p class="fs14 font-weight-bold text-right mt12">
              <a v-on:click="moveEstimateDitail()" target="_blank" class="color-green2 text-decoration-none icon-chevron-right">詳細金額</a>
            </p>
          </div>
          <p class="fs14 font-weight-bold mb20">車検が完了しました。車検料金をお支払いの上お車をお引き取りにお越しください</p>
          <p class="fs14 line-height1_6">アプリでのお支払いは、下記ボタンよりクレジット決済がご利用いただけます。</p><br>
          <button v-on:click="callGmoApi()" class="button fs16 w100p mb12 mb0 pd16 radius200" >クレジットカードで支払う</button>
          <div class="bg-gray1 pt24 pr16 pb20 pl16 mb8 radius8">
            <p class="fs14 font-weight-bold mb20">現金をご利用の方は店頭にて直接お支払いください</p>
            <p class="fs14 line-height1_6">現金でのお支払いをご希望される場合は、お車をお引き取りの際に店頭にてお支払いいただけます。店頭へのご来店をお待ちしております。</p>
          </div>
        </section>

        <section class="section white-panel mb2p pt20 pr28 pb28 pl28">
          <h2 class="fs16 mt4 mb4">車検実施店舗</h2>
          <table class="table w100p fs14 line-height1_2">
            <tbody>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8 w25p">店舗名</th>
                <td class="va-top pt8 pl8">{{this.ssInfo.ss_name}}</td>
              </tr>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8">住所</th>
                <td class="va-top pt8 pl8">{{this.ssInfo.address}}</td>
              </tr>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8">電話番号</th>
                <td class="va-top pt8 pl8"><a v-on:click="calling()" class="color-green2">{{this.ssInfo.tel}}</a></td>
              </tr>
              <tr v-if="this.ssInfo.opening_hours_weekday || this.ssInfo.opening_hours_saturday || this.ssInfo.opening_hours_sunday || this.ssInfo.opening_hours_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">営業時間</th>
                <td class="va-top pt8 pl8">
                  <template v-if="this.ssInfo.opening_hours_weekday">平日 {{ this.ssInfo.opening_hours_weekday }}<br></template>
                  <template v-if="this.ssInfo.opening_hours_saturday">土曜 {{ this.ssInfo.opening_hours_saturday }}<br></template>
                  <template v-if="this.ssInfo.opening_hours_sunday">日曜 {{ this.ssInfo.opening_hours_sunday }}<br></template>
                  <template v-if="this.ssInfo.opening_hours_holiday">祝日 {{ this.ssInfo.opening_hours_holiday }}</template></td>
              </tr>
              <tr v-if="this.ssInfo.opening_hours_carcare">
                <th class="font-weight-normal color-font2 va-top pt8">カーケア<br>営業時間</th>
                <td class="va-top pt8 pl8">{{this.ssInfo.opening_hours_carcare}}</td>
              </tr>
              <tr v-if="this.ssInfo.regular_holiday">
                <th class="font-weight-normal color-font2 va-top pt8">定休日</th>
                <td class="va-top pt8 pl8">{{this.ssInfo.regular_holiday}}</td>
              </tr>
              <tr>
                <th class="font-weight-normal color-font2 va-top pt8">整備工場</th>
                <td v-if="ssInfo.factory_type_flag === 2" class="va-top pt8 pl8">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 3" class="va-top pt8 pl8">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 4" class="va-top pt8 pl8">提携工場で整備いたします。詳細は店舗へご確認ください。</td>
              </tr>
            </tbody>
          </table>
        </section>

      </article>
    </div>

    <div class="modal_overlay">
      <div class="modal_container">
        <div class="modal_body radius8 pd28 mt8p mb8p">
          <p class="text-center mb12"><img src="/lib/images/ic_cash_1.svg" alt=""></p>
          <h2 class="fs18 mb4">現金でのお支払いを受け付けます</h2>
          <p class="fs14 line-height1_6 mb24">車検代金を用意し、店頭にてご精算をお願いいたします。</p>
          <button v-on:click="moveInspectionTop()" class="button fs16 w100p mb12 mb0 pd16 radius200">OK</button>
          <button v-on:click="modalClose()" class="button button-gray fs16 w100p mb12 mb0 pd16 radius200">キャンセル</button>
        </div>
        <!-- /.modal_body -->
      </div>
      <!-- /.modal_container -->
    </div>
    <!-- カーケアTOPに戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="$route.query.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="$route.query.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="$route.query.otoken">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionData.osVersion">
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import gmoApi from '@/store/Api/gmo'
import inspection from '@/store/Api/inspection'
import ssApi from '@/store/Api/Common/ss'
import Loading from '@/views/v2/Loading.vue'
import modal from '@/assets/v2/modal'
import { useGmoPageStore } from '@/store/gmoPage'
import { useInspectionDetailStore } from '@/store/inspectionDetail'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

export default {
  data: () => ({
    loading: true,
    ssInfo: [],
    divModalOpenClass: 'content-wrapper',
    inspectionDetail: {},
    nativeData: {},
    varsionData: {}
  }),
  methods: {
    ...mapActions('INSPECTION_SETTLEMENT', [
      'setInspectionSettlement'
    ]),
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    callGmoApi () {
      this.nativeEVENTSet('ShakenKessaiButton', 'MOVED_CREDITCARD', 'TAP')
      this.inspectionSettlement.DateTime = this.getNowYMD()
      this.inspectionSettlement.OrderID = this.createOrderID()
      this.gmoApiPost(this.inspectionSettlement)
    },
    async gmoApiPost (inspectionSettlement) {
      await gmoApi.post(inspectionSettlement).then(res => {
        const gmoPage = res.data
        // 戻るボタンの出し分け
        this.appDisplayBack(false)
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoPage = gmoPage
        this.$router.push({
          name: 'PaymentV2'
        })
      }).catch(e => {
        this.openErrorModal('エラーが発生しました。')
      })
    },
    modalClose () {
      this.divModalOpenClass = 'content-wrapper'
    },
    modalOpne () {
      this.divModalOpenClass = 'content-wrapper modal_open'
    },
    moveInspectionTop () {
      this.nativeEVENTSet('ShakenKessaiButton', 'MOVED_GENKIN', 'TAP')
      inspection.changePyingCash(this.inspectionSettlement.inspectionID)
      this.$router.push({
        name: 'InspectionTopV2',
        query: {
          tsid: this.$route.query.tsid,
          otoken: this.$route.query.otoken,
          popinfoid: this.$route.query.popinfoid,
          x_cls_app_version: this.versionData.appVersion,
          x_cls_os: this.versionData.appVersion.platform,
          x_cls_os_version: this.versionData.appVersion.osVersion
        }
      })
    },
    moveEstimateDitail () {
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = this.nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = this.versionData
      const inspectionDetailStore = useInspectionDetailStore()
      inspectionDetailStore.detail = this.inspectionDetail
      this.$router.push({
        name: 'EstimateDetailV2'
      })
    },
    getNowYMD () {
      const dt = new Date()
      const y = dt.getFullYear()
      const mo = ('00' + (dt.getMonth() + 1)).slice(-2)
      const d = ('00' + dt.getDate()).slice(-2)
      const h = ('00' + dt.getHours()).slice(-2)
      const mi = ('00' + dt.getMinutes()).slice(-2)
      const s = ('00' + dt.getSeconds()).slice(-2)
      const result = y + mo + d + h + mi + s
      return result
    },
    createOrderID () {
      return this.ssInfo.ss_code + '-' + this.inspectionSettlement.inspectionID
    },
    calling () {
      this.nativeEVENTSet('ShakenKessaiButton', 'TEL_BUTTON', 'TAP')
      window.location.href = 'tel:' + this.ssInfo.tel
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('INSPECTION_SETTLEMENT', [
      'inspectionSettlement'
    ]),
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.x_cls_app_version
      getData.platform = this.$route.query.x_cls_os
      getData.osVersion = this.$route.query.x_cls_os_version
      return getData
    },
    gmoPageStore: function () {
      return useGmoPageStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    }
  },
  async mounted () {
    this.$loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
    this.$loadScript('/lib/js/main.js')

    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false
    const tsid = this.$route.query.tsid
    const otoken = this.$route.query.otoken
    const popinfoid = this.$route.query.popinfoid
    this.inspectionSettlement.version = 'v2'
    this.nativeData = {
      tsid,
      otoken,
      popinfoid
    }

    // バージョン情報が一つでも未定義の場合はエラーダイアログを表示.
    if (this.isCLSAppVersionError(this.$route.query.x_cls_app_version, this.$route.query.x_cls_os, this.$route.query.x_cls_os_version)) {
      this.openErrorModal('アプリバージョンの認証でエラーが発生しました。')
      isApiError = true
      return
    } else {
      this.versionData.appVersion = this.versionData.appVersion ? this.versionData.appVersion : '0.0.0'
      this.versionData.platform = this.versionData.platform ? this.versionData.platform : 'iRidge'
      this.versionData.osVersion = this.versionData.osVersion ? this.versionData.osVersion : '0.0'
    }

    // バージョニング対応
    // GMOページからの戻り先のURLで各種バージョン情報が必要なため、
    // APIのリクエストに含める.
    this.inspectionSettlement.appVersion = this.versionData.appVersion
    this.inspectionSettlement.platform = this.versionData.platform
    this.inspectionSettlement.osVersion = this.versionData.osVersion

    await inspection.get(tsid).then(res => {
      // データがない場合、アプリTOPに遷移させるようにする
      if (res.data.inspections.length === 0) {
        if ('Android' in window) {
          Android.homeBack()
        } else if ('webkit' in window) {
          webkit.messageHandlers.homeBack.postMessage('')
        }
      }
      this.inspectionSettlement.otoken = otoken
      this.inspectionSettlement.popinfoid = popinfoid
      this.inspectionSettlement.ts_id = res.data.inspections[0].ts_id
      this.inspectionSettlement.inspectionID = res.data.inspections[0].id
      this.inspectionSettlement.Amount = res.data.inspections[0].payment_price
      this.setInspectionSettlement(this.inspectionSettlement)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })
    this.inspectionDetail = (await inspection.getDetail(this.inspectionSettlement.inspectionID)).data
    // ステータスが車検完了以外の場合はアプリTOPに遷移させるようにする。
    if (this.inspectionDetail[0].status_code !== 4) {
      if ('Android' in window) {
        Android.homeBack()
      } else if ('webkit' in window) {
        webkit.messageHandlers.homeBack.postMessage('')
      }
    }
    // SS情報マスタ取得。
    await ssApi.get(this.inspectionDetail[0].inspection_estimate.ss_code).then(res => {
      this.setSsInfo(res.data.body.ss_info)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    this.nativePVset('SHAKEN_Kessai')
    if (!isApiError) {
      this.loading = false
    }
  },
  components: {
    Loading
  }
}
</script>

<style></style>
